/* eslint-disable react/prop-types */
import { Cancel, Check, Delete, Edit } from "@mui/icons-material";
import AddIcon from "@mui/icons-material/Add";
import InfoIcon from "@mui/icons-material/Info";
import {
  Alert,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Snackbar,
  Stack,
  Tooltip,
  Typography,
  darken,
} from "@mui/material";
import { MailIcon } from "@primer/octicons-react";
import DialogProgress from "components/CircularProgressWithLabel/dialogProgress";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import MDBadge from "components/MDBadge";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import SelectCustomer from "components/SelectCustomer";
import { setHomePage, useMaterialUIController } from "context";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { useEffect, useMemo, useRef, useState } from "react";
import { JsonTool } from "utils/jsonTools";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";

import {
  API_ROUTES,
  API_ROUTES_V2,
  CODE_QUANGNAM,
  ID_GROUP_CHUTHE,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  ID_GROUP_CAPTINH,
} from "../../utils/constants";
import DetailSanPham from "./detailSanPham";
import FormSanPham from "./formSanPham";
import InformationSanPham from "./informationSanPham";
import useAxiosPrivateForm from "../../hooks/useAxiosPrivateForm";
import PrintIcon from "@mui/icons-material/Print";
import PrintSanPham from "./printSanPham";

const ALLVALUE = { ma: "ALL", ten: "Tất cả" };

const dictTrangThai = {
  1: "Chưa công nhận",
  2: "Chờ đánh giá",
  3: "Đã công nhận",
  4: "Hết hiệu lực",
};
const dictColorTrangThai = {
  1: "info",
  2: "warning",
  3: "error",
  4: "primary",
};

function SanPhamOCOP() {
  const [controller, dispatch] = useMaterialUIController();
  useEffect(() => {
    setHomePage(dispatch, false);
  }, []);
  const { user } = useAuth();
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState("Edit");
  const [tableData, setTableData] = useState({});
  const [tableInfor, setTableInfor] = useState({});
  const [dataRow, setDataRow] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const axiosPrivateInstance = useAxiosPrivate();
  const axiosForm = useAxiosPrivateForm();
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [title, setTitle] = useState("");
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });

  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionNhomSanPham, setOptionNhomSanPham] = useState([]);
  const [optionChuThe, setOptionChuThe] = useState([]);
  const searchParams = new URLSearchParams(location.search);
  const [paramsState, setParamsState] = useState({
    nhomsanpham: ALLVALUE.ma,
    hang: ALLVALUE.ma,
    trangthaisanpham: ALLVALUE.ma,
    expired: searchParams.get("expired") || false,
  });
  const [checked, setChecked] = useState(Boolean(paramsState.expired));
  const [openDetail, setOpenDetail] = useState(false);
  const [openInfor, setOpenInfor] = useState(false);
  const [detailState, setDetailState] = useState();
  //progress
  const _openDialog = useRef(false);
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const [valueProgress, setValueProgress] = useState(0);

  //print
  const [detailPrint, setDetailPrint] = useState();
  const [openPrint, setOpenPrint] = useState(false);
  //Kiểm tra nhóm người dùng với id Group
  const checkGroupUser = (user, idGroup) => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == idGroup)) {
        check = true;
      }
    }
    return check;
  };
  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8 - phường/xã
  const isGroupNumberEight = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);
  //Kiểm tra nhóm người dùng là 9
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);
  const fieldInforDetail = useMemo(() => {
    const result = [
      {
        key: "chuthe_ten",
        name: "Chủ thể",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "nhomsanphan_ten",
        name: "Nhóm Sản phẩm",
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        key: "ma",
        name: "Mã Sản phẩm",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        key: "ten",
        name: "Sản phẩm",
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        key: "ngaycongnhan",
        name: "Ngày công nhận",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        key: "quycach",
        name: "Quy cách",
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        key: "tieuchuan",
        name: "Tiêu chuẩn",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "quymo",
        name: "Quy mô",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "trangthaisanpham_ten",
        name: "Trạng thái",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "hang_ten",
        name: "Hạng",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        key: "ghichu",
        name: "Ghi chú",
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);

  const optionHang = [
    {
      id: "1",
      ten: "1 sao",
    },
    {
      id: "2",
      ten: "2 sao",
    },
    {
      id: "3",
      ten: "3 sao",
    },
    {
      id: "4",
      ten: "4 sao",
    },
    {
      id: "5",
      ten: "5 sao",
    },
  ];
  const optionTrangthai = [
    {
      id: "1",
      ten: "Sản phẩm chưa công nhận",
    },
    {
      id: "2",
      ten: "Sản phẩm đang chờ đánh giá",
    },
    {
      id: "3",
      ten: "Sản phẩm đã công nhận",
    },
    {
      id: "4",
      ten: "Sản phẩm đã hết hạn",
    },
  ];
  useEffect(() => {
    const fetchDataHuyen = async (codeProvince) => {
      try {
        const response = await axiosPrivateInstance.get(API_ROUTES.GETHUYEN, {
          params: { tinh: codeProvince },
        });
        setOptionDistrict(response?.data);
      } catch (error) {
        console.log(error);
        return;
      }
    };
    const fetchDataDataNhomSanPham = async () => {
      try {
        const response = await axiosPrivateInstance.get("nhomsanpham");
        setOptionNhomSanPham(response.data["data"]);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    fetchDataHuyen(CODE_QUANGNAM);
    fetchDataDataNhomSanPham();
    return () => {
      setOpenLoadingDialog(false);
    };
  }, []);

  //kiểm tra đang đăng nhập với nhóm chủ thể
  const isOwner = useMemo(() => {
    let check = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == ID_GROUP_CHUTHE)) {
        check = true;
      }
    }
    return check;
  }, [user]);
  useEffect(() => {
    const fetchDataDataChuThe = async (username, maquan) => {
      try {
        const response = await axiosPrivateInstance.get(
          API_ROUTES.QUANLYCHUTHE,
          {
            params: { username: username, maquan: maquan },
          }
        );
        setOptionChuThe(response.data["data"]);
      } catch (error) {
        setIsError(true);
        return;
      }
    };
    if (isGroupNumberSeven) {
      fetchDataDataChuThe(isOwner ? user?.username : null, user.maquan);
    } else {
      fetchDataDataChuThe(isOwner ? user?.username : null, null);
    }
  }, [isOwner]);

  //nhóm sản phẩm
  const handleChangeSelect = (e, value) => {
    setParamsState((prev) => ({
      ...prev,
      nhomsanpham: value,
    }));
  };
  //Hạng sao
  const handleChangeHang = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      hang: value,
    }));
  };
  const handleChangeTrangthai = (e) => {
    let { value } = e.target;
    setParamsState((prev) => ({
      ...prev,
      trangthaisanpham: value,
    }));
  };
  // lấy hết hạn sản phẩm
  const handleChangeExp = (e) => {
    setChecked(e.target.checked);
    setParamsState((prev) => ({
      ...prev,
      expired: e.target.checked,
    }));
  };
  const handleDelete = async () => {
    try {
      await axiosPrivateInstance.delete(
        API_ROUTES.SANPHAM + "/" + selectedRow.id
      );
      // Remove the selected row from the data
      setTableData((prevData) =>
        prevData.filter((row) => row.id !== selectedRow.id)
      );
      setAlert({
        alert: true,
        message: "Xoá bản ghi thành công!",
        type: "success",
      });
    } catch (error) {
      const ms = error.response.data;
      setAlert({ alert: true, message: ms.error, type: "warning" });
    }
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleOpenDeleteConfirmation = (row) => {
    // Set the selected row and open the delete confirmation dialog
    setSelectedRow(row);
    setDeleteConfirmationOpen(true);
  };

  const handleCloseDeleteConfirmation = () => {
    // Close the delete confirmation dialog
    setDeleteConfirmationOpen(false);
  };

  const handleError = (isHasUploadFile, error) => {
    if (isHasUploadFile) {
      _openDialog.current = true;
      setOpenLoadingDialog(false);
    }
    if (error?.response?.data) {
      let validErrors = {};
      let data = error?.response?.data;
      if (Array.isArray(data)) {
        let value = "";
        value = data?.join(";");
        validErrors = { ...validErrors, another: value };
      } else {
        Object.entries(data).forEach(([key, value]) => {
          let val = "";
          if (Array.isArray(value)) {
            value.map((item) => {
              val += item;
            });
          } else {
            val = value;
          }
          validErrors = { ...validErrors, [key]: val };
        });
      }
      setValidationErrors(validErrors);
    } else {
      setAlert({
        alert: true,
        message: error?.message || "Lỗi! Vui lòng thử lại sau!",
        type: "error",
      });
      console.log(error);
    }
  };
  const handleSave = async (values) => {
    if (_openDialog.current) {
      _openDialog.current = false;
    }
    //khi post, put data tính progress complete
    const configCircularProgressWithLabel = {
      onUploadProgress: function (progressEvent) {
        !openLoadingDialog &&
          !_openDialog.current &&
          setOpenLoadingDialog(true);
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        setValueProgress(percentCompleted);
      },
    };
    const isHasUploadFile = values?.tepdinhkem?.length > 0;
    let config = {};
    if (isHasUploadFile) {
      config = { ...configCircularProgressWithLabel };
    }
    const handleToEditSuccess = () => {
      setAlert({
        alert: true,
        message: "Cập nhật thành công!",
        type: "success",
      });
      setValidationErrors({});
      setModalOpen(false);
      fetchData(paramsState, pagination, user);
    };
    const handleToCreateSuccess = (response) => {
      let rowAdd = response.data;
      tableData.unshift(rowAdd);
      setTableData([...tableData]);
      setAlert({
        alert: true,
        message: "Thêm mới thành công!",
        type: "success",
      });
      setValidationErrors({});
      setModalOpen(false);
    };
    if (action == "Edit") {
      await axiosForm
        .put(
          API_ROUTES_V2.SANPHAM + "/" + values.id,
          { ...values },
          { ...config }
        )
        .then((response) => {
          if (response?.data) {
            if (isHasUploadFile) {
              setValueProgress(100);
              setTimeout(() => {
                setOpenLoadingDialog(false);
                handleToEditSuccess();
              }, [400]);
            } else {
              handleToEditSuccess();
            }
          }
        })
        .catch((error) => {
          handleError(isHasUploadFile, error);
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    } else {
      axiosForm
        .post(
          API_ROUTES_V2.SANPHAM,
          {
            ...values,
          },
          { ...config }
        )
        .then((response) => {
          if (response?.data) {
            if (isHasUploadFile) {
              setValueProgress(100);
              setTimeout(() => {
                setOpenLoadingDialog(false);
                handleToCreateSuccess(response);
              }, [400]);
            } else {
              handleToCreateSuccess(response);
            }
          }
        })
        .catch((error) => {
          handleError(isHasUploadFile, error);
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    }
  };

  // Lấy toàn bộ dữ liệu
  const fetchData = async (
    { nhomsanpham, hang, trangthaisanpham, expired },
    { pageIndex, pageSize },
    user
  ) => {
    let isOwner = false;
    if (user && user.id) {
      if (user?.group?.find((item) => item?.id == ID_GROUP_CHUTHE)) {
        isOwner = true;
      }
    }
    if (!tableData.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    try {
      let body = {
        nhomsanpham: nhomsanpham == ALLVALUE.ma ? undefined : nhomsanpham,
        hang: hang == ALLVALUE.ma ? undefined : hang,
        maquan: isGroupNumberSeven || isHoiDong ? user.maquan : undefined,
        maphuong: isGroupNumberEight ? user.maphuong : undefined,
        trangthaisanpham:
          trangthaisanpham == ALLVALUE.ma ? undefined : trangthaisanpham,
        expired: expired,
        pageNumber: pageIndex + 1,
        countNumber: pageSize,
        username: isOwner ? user?.username : undefined,
      };
      const response = await axiosPrivateInstance.get(API_ROUTES.SANPHAM, {
        params: body,
      });
      setRowCount(response.data?.totalRecord);
      setTableData(response.data?.data);
    } catch (error) {
      setIsError(true);
      return;
    }
    setIsError(false);
    setIsLoading(false);
    setIsRefetching(false);
  };

  useEffect(() => {
    fetchData(paramsState, pagination, user);
  }, [paramsState, pagination, user]);

  const handleToCloseDetail = () => {
    setOpenDetail(false);
    setDetailState(null);
  };
  const handleToCloseInformation = () => {
    setOpenInfor(false);
    setTableInfor({});
  };

  const handleToClickDetail = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.SANPHAM + "/" + id
      );
      let detail = { ...response.data };
      detail["ngaycongnhan"] =
        detail["ngaycongnhan"] && dayjs(detail["ngaycongnhan"]).isValid()
          ? dayjs(detail["ngaycongnhan"]).format("DD/MM/YYYY")
          : null;
      setDetailState(detail);
      setOpenDetail(true);
    } catch (error) {
      console.log(error);
      return;
    }
  };
  const handleToClickInformation = async () => {
    const isOwner = checkGroupUser(user, ID_GROUP_CHUTHE);
    const isGroupSeven = checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
    const isGroupHoiDong = checkGroupUser(user, ID_GROUP_HOIDONG);
    const body = {
      expired: true,
      maquan: isGroupSeven || isGroupHoiDong ? user.maquan : undefined,
      username: isOwner ? user?.username : undefined,
      trangthaithongbao: 1,
    };
    const queries = JsonTool.convertToQueryString(body);
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.SANPHAM + "?" + queries
      );
      setTableInfor(response.data["data"]);
    } catch (error) {
      console.log(error);
      return;
    }
    setOpenInfor(true);
  };
  const columns = useMemo(
    () => [
      {
        accessorKey: "id",
        header: "id",
        enableEditing: false,
        enableHiding: false,
        enableColumnActions: false,
      },
      {
        accessorKey: "nhomsanpham_ten",
        header: "Nhóm sản phẩm",
        size: 150,
      },
      // {
      //   accessorKey: "ma",
      //   header: "Mã sản phẩm",
      //   size: 120,
      // },
      {
        accessorKey: "ten",
        header: "Tên sản phẩm",
        size: 200,
      },
      {
        accessorKey: "hang",
        header: "Hạng",
        size: 95,
        muiTableBodyCellProps: ({ cell }) => ({
          sx: {
            align: "center",
            backgroundColor:
              cell.getValue() > 3 ? "rgba(22, 184, 44, 0.5)" : undefined,
            fontWeight:
              cell.column.id === "hang" && cell.getValue() > 3 ? "700" : "400",
          },
        }),
      },
      {
        accessorKey: "ngaycongnhan",
        header: "Ngày công nhận",
        size: 120,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return dayjs(value).isValid()
            ? dayjs(value).format("DD/MM/YYYY")
            : value;
        },
      },
      {
        accessorKey: "trangthaisanpham",
        header: "Trạng thái",
        size: 90,
        Cell: ({ cell }) => {
          const value = cell.getValue();
          return (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={dictTrangThai[value]}
                color={dictColorTrangThai[value]}
                variant="gradient"
              />
            </MDBox>
          );
        },
      },
    ],
    []
  );

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ alert: false, message: null, type: null });
  };
  const handelEditClick = async (id) => {
    // const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.SANPHAM + "/" + id
      );
      setDataRow({ ...response.data });
    } catch (error) {
      setIsError(true);
      return;
    }
    setAction("Edit");
    setTitle("Chỉnh sửa sản phẩm OCOP");
    setValidationErrors({});
    setModalOpen(true);
  };

  //print
  const handleToClickPrint = async (row) => {
    const id = row.getValue("id");
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.SANPHAM + "/" + id
      );
      setDetailPrint(response.data);
      setOpenPrint(true);
    } catch (error) {
      console.log(error);
      return;
    }
  };

  const handleToClosePrint = () => {
    setOpenPrint(false);
    setDetailPrint(null);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        pt={6}
        py={3}
        sx={{
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          px: 3,
        }}
      >
        <Grid
          container
          spacing={2}
          rowSpacing={2}
          columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        >
          <Grid item xs={12} md={5} lg={5}>
            <SelectCustomer
              keyValue="nhomsanpham"
              label="Nhóm sản phẩm"
              labelName="ten"
              option={optionNhomSanPham}
              onChange={handleChangeSelect}
              state={paramsState.nhomsanpham}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <SelectCustomer
              keyValue="hang"
              label="Hạng"
              labelName="ten"
              option={optionHang}
              onChange={handleChangeHang}
              state={paramsState.hang}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={2} lg={2}>
            <SelectCustomer
              keyValue="trangthaisanpham"
              label="Trạng thái sản phẩm"
              labelName="ten"
              option={optionTrangthai}
              onChange={handleChangeTrangthai}
              state={paramsState.trangthaisanpham}
              unicode="id"
            />
          </Grid>
          <Grid item xs={12} md={3} lg={3}>
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={checked}
                    onChange={handleChangeExp}
                    inputProps={{ "aria-label": "primary checkbox" }}
                  />
                }
                label="Lấy sản phẩm hết hạn"
              />
            </FormGroup>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox py={3}>
        {alert.alert && (
          <Snackbar
            autoHideDuration={3000}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={alert.alert}
            onClose={handleCloseAlert}
          >
            <Alert onClose={handleCloseAlert} severity={alert.type}>
              {alert.message}
            </Alert>
          </Snackbar>
        )}
        <MaterialReactTable
          muiToolbarAlertBannerProps={
            isError
              ? {
                  color: "error",
                  children: "Lỗi khi lấy dữ liệu",
                }
              : undefined
          }
          enableRowNumbers
          rowNumberMode="static"
          columns={columns}
          data={tableData}
          enableFilters={true}
          enableHiding={false}
          enableColumnOrdering={false}
          enableDensityToggle={true}
          enableColumnResizing
          enableGrouping
          enableEditing
          manualPagination
          onPaginationChange={setPagination}
          rowCount={rowCount}
          localization={MRT_Localization_VI}
          positionActionsColumn="last"
          displayColumnDefOptions={{
            "mrt-row-actions": {
              size: isHoiDong ? 120 : 130,
            },
          }}
          renderRowActions={({ row, table }) => (
            <Box sx={{ display: "flex" }}>
              {isHoiDong ||
              isGroupNumberEight ||
              isGroupNumberSeven ||
              isGroupNumberNine ? (
                <>
                  <Tooltip arrow placement="left" title="In">
                    <IconButton
                      color="error"
                      onClick={() => handleToClickPrint(row)}
                    >
                      <PrintIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip arrow placement="left" title="Chi tiết">
                    <IconButton
                      color="success"
                      onClick={() => handleToClickDetail(row)}
                    >
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                </>
              ) : (
                <>
                  <Tooltip arrow placement="left" title="In">
                    <IconButton
                      color="error"
                      onClick={() => handleToClickPrint(row)}
                    >
                      <PrintIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip arrow placement="left" title="Chi tiết">
                    <IconButton
                      color="success"
                      onClick={() => handleToClickDetail(row)}
                    >
                      <InfoIcon />
                    </IconButton>
                  </Tooltip>
                  <Tooltip arrow placement="left" title="Chỉnh sửa">
                    <IconButton
                      color="info"
                      onClick={() => handelEditClick(row.original?.id)}
                    >
                      <Edit />
                    </IconButton>
                  </Tooltip>
                  <Tooltip arrow placement="right" title="Xoá">
                    <IconButton
                      color="primary"
                      onClick={() => {
                        let _data = [];
                        _data["id"] = row.getValue("id");
                        _data["ten"] = row.getValue("ten");
                        handleOpenDeleteConfirmation(_data);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                </>
              )}
            </Box>
          )}
          renderTopToolbarCustomActions={() => (
            <Stack spacing={2} direction="row" color="white">
              {isHoiDong ||
              isGroupNumberEight ||
              isGroupNumberSeven ||
              isGroupNumberNine ? (
                <></>
              ) : (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ color: "#ffffff" }}
                  onClick={() => {
                    setAction("New");
                    setTitle("Thêm mới sản phẩm OCOP");
                    setDataRow({});
                    setValidationErrors({});
                    setModalOpen(true);
                  }}
                >
                  Tạo mới
                </Button>
              )}
              {/* {!isHoiDong || !isGroupNumberEight ? (
                <>
                  <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{ color: "#ffffff" }}
                    onClick={() => {
                      setAction("New");
                      setTitle("Thêm mới sản phẩm OCOP");
                      setDataRow({});
                      setValidationErrors({});
                      setModalOpen(true);
                    }}
                  >
                    Tạo mới
                  </Button>
                </>
              ) : (
                <></>
              )} */}
              {!isHoiDong && !isOwner && checked && tableData.length > 0 ? (
                <>
                  <MDButton
                    color="primary"
                    variant="contained"
                    startIcon={<MailIcon />}
                    sx={{ color: "#ffffff" }}
                    onClick={() => handleToClickInformation()}
                  >
                    Thông báo
                  </MDButton>
                </>
              ) : (
                <></>
              )}
            </Stack>
          )}
          initialState={{
            isLoading: true,
            columnVisibility: {
              id: false,
            },
            density: "compact",
          }}
          state={{
            pagination,
            isLoading,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
          }}
          muiTablePaperProps={{
            elevation: 0,
            sx: {
              borderRadius: "0",
              border: "1px solid rgb(211 225 245)",
              backgroundColor: "#fff",
            },
          }}
          muiTableBodyProps={{
            sx: (theme) => ({
              "& tr:nth-of-type(odd)": {
                backgroundColor: darken(theme.palette.background.default, 0.1),
              },
            }),
          }}
          // muiTableBodyRowProps={({ row }) => ({
          //   sx: {
          //     backgroundColor:
          //       row.getValue("hieuluc") == 1
          //         ? "rgba(255, 54, 33, 0.18)"
          //         : "transparent",
          //   },
          // })}
        />
        <FormSanPham
          data={dataRow}
          open={modalOpen}
          title={title}
          onClose={() => {
            setModalOpen(false);
            setValidationErrors({});
          }}
          onSubmit={handleSave}
          validationErrors={validationErrors}
          action={action}
          dataHuyen={optionDistrict}
          dataNhomSanPham={optionNhomSanPham}
          dataChuThe={optionChuThe}
          isOwner={isOwner}
        />
        <DetailSanPham
          data={detailState}
          open={openDetail}
          onClose={handleToCloseDetail}
          fieldInfor={fieldInforDetail}
        />
        <InformationSanPham
          data={tableInfor}
          open={openInfor}
          onClose={handleToCloseInformation}
        />
        {/* Delete Confirmation Dialog */}
        <Dialog
          open={deleteConfirmationOpen}
          onClose={handleCloseDeleteConfirmation}
        >
          <DialogTitle>Xoá bảng ghi</DialogTitle>
          <DialogContent>
            <Typography>
              Bạn muốn xoá sản phẩm: {selectedRow?.ten} này không?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              color="secondary"
              type="button"
              variant="contained"
              startIcon={<Cancel />}
              size="small"
              onClick={handleCloseDeleteConfirmation}
              sx={{ color: "#ffffff", float: "right", mr: 1 }}
            >
              Hủy
            </Button>
            <MDButton
              color="primary"
              onClick={handleDelete}
              variant="contained"
              startIcon={<Check />}
              size="small"
              sx={{ float: "right", mr: 1 }}
            >
              Đồng ý
            </MDButton>
          </DialogActions>
        </Dialog>
      </MDBox>
      <DialogProgress open={openLoadingDialog} value={valueProgress} />
      <PrintSanPham
        data={detailPrint}
        open={openPrint}
        onClose={handleToClosePrint}
      />
      <Footer />
    </DashboardLayout>
  );
}

export default SanPhamOCOP;
